import Vue from "vue";
import router from "./../../router";
import { i18n } from "./../../main";

export async function fetchAddresses({ commit }, filtro) {
  try {
    commit("setLoading", true, { root: true });

    let res = await fetch(Vue.prototype.$apiRoute + "domicilios", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      params: filtro
    });

    if (res.ok) {
      let resJson = await res.json();
      commit("setAddresses", resJson);
    } else throw true;
  } catch (error) {
    Vue.prototype.$toast(i18n.t('mensajes.inicioSesion'), {
      color: "blue"
    });
    commit("Auth/logout", null, { root: true });
    router.push("login");
  } finally {
    commit("setLoading", false, { root: true });
  }
}

export async function addAddress({ commit }, address) {
  try {
    let data = {
      AvisoEmailDestino: address.AvisoEmailDestino,
      AvisoEmailRemitente: address.AvisoEmailRemitente,
      AvisoSmsDestino: address.AvisoSmsDestino,
      AvisoSmsRemitente: address.AvisoSmsRemitente,
      Codigo: address.Codigo,
      CodigoCliente: address.CodigoCliente,
      CodigoPostal: address.CodigoPostal,
      Corporativo: address.Corporativo,
      DepartamentoCliente: address.DepartamentoCliente,
      Direccion: address.Direccion,
      Email: address.Email,
      Id: address.Id,
      IdCliente: address.IdCliente,
      IdDomicilio: address.IdDomicilio,
      IdPais: address.IdPais,
      IdPoblacion: address.IdPoblacion,
      Latitud: address.Latitud,
      Longitud: address.Longitud,
      Marca: address.Marca,
      MasDatos: address.MasDatos,
      Movil: address.Movil,
      Nif: address.Nif,
      Nombre: address.Nombre,
      Nombre2: address.Nombre2,
      NumeroDireccion: address.NumeroDireccion,
      Observacion: address.Observacion,
      Pais: address.Pais,
      PisoDireccion: address.PisoDireccion,
      Poblacion: address.Poblacion,
      Pointer: address.Pointer,
      Referencia: address.Referencia,
      Telefono: address.Telefono,
      TipoDireccion: address.TipoDireccion
    };

    console.log("Token: " + window.localStorage.getItem("_token"));

    let res = await fetch(Vue.prototype.$apiRoute + "domicilios", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      let resJson = await res.json();
      Vue.prototype.$toast(resJson.Message, { color: "red" });
    } else {
      Vue.prototype.$toast(i18n.t('mensajes.direccionCreada'), {
        color: "green"
      });
    }
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para crear las direcciones ha finalizado.");
  }
}

export async function importAddress({ commit }, file) {
  try {
    console.log("Token: " + window.localStorage.getItem("_token"));
    console.log("importAddress "+file);

    let formData = new FormData();
    formData.append('file', file);

    let res = await fetch(Vue.prototype.$apiRoute + "domicilios/importar", {
      method: "POST",
      headers: {
        Accept: "application/json",
        //"Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: formData
    });

    let resJson = await res.json();

    if (!res.ok) {
      Vue.prototype.$toast(resJson.Message, { color: "red" });
    } else {
      Vue.prototype.$toast(resJson, {
        color: "green"
      });
    }
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para importar direcciones ha finalizado.");
  }
}

export async function updateAddress({ commit }, address) {
  try {
    let data = {
      AvisoEmailDestino: address.AvisoEmailDestino,
      AvisoEmailRemitente: address.AvisoEmailRemitente,
      AvisoSmsDestino: address.AvisoSmsDestino,
      AvisoSmsRemitente: address.AvisoSmsRemitente,
      Codigo: address.Codigo,
      CodigoCliente: address.CodigoCliente,
      CodigoPostal: address.CodigoPostal,
      Corporativo: address.Corporativo,
      DepartamentoCliente: address.DepartamentoCliente,
      Direccion: address.Direccion,
      Email: address.Email,
      Id: address.Id,
      IdCliente: address.IdCliente,
      IdDomicilio: address.IdDomicilio,
      IdPais: address.IdPais,
      IdPoblacion: address.IdPoblacion,
      Latitud: address.Latitud,
      Longitud: address.Longitud,
      Marca: address.Marca,
      MasDatos: address.MasDatos,
      Movil: address.Movil,
      Nif: address.Nif,
      Nombre: address.Nombre,
      Nombre2: address.Nombre2,
      NumeroDireccion: address.NumeroDireccion,
      Observacion: address.Observacion,
      Pais: address.Pais,
      PisoDireccion: address.PisoDireccion,
      Poblacion: address.Poblacion,
      Pointer: address.Pointer,
      Referencia: address.Referencia,
      Telefono: address.Telefono,
      TipoDireccion: address.TipoDireccion
    };

    //console.log(JSON.stringify(data))
    //console.log('Token: ' + window.localStorage.getItem('_token'))

    let res = await fetch(Vue.prototype.$apiRoute + "domicilios", {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      },
      body: JSON.stringify(data)
    });

    
    if (!res.ok) {
      let resJson = await res.json();
      Vue.prototype.$toast(resJson.Message, { color: "red" });
    } else {
      Vue.prototype.$toast(i18n.t('mensajes.direccionActualizada'), {
        color: "green"
      });
    }

    return res.ok;
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para actualizar una direcciones ha finalizado.");
  }
}

/* export async function updateAddressStatus({ commit, dispatch }, address) {
  try {
      await Vue.axios({
      method: 'PUT',
      url: `/domicilios/${address.id}`,
      data: {
        Codigo: address.Codigo,
        Nombre: address.Nombre,
        Direccion: address.Direccion,
        TipoDireccion: 'c/',
        NumeroDireccion: 10,
        CodigoPostal: address.CodigoPostal,
        Pais: address.Pais,
        Poblacion: address.Poblacion,
        PisoDireccion: 0,
        Nombre2: '',
        MasDatos: '',
        Telefono: address.Movil,
        Email: '',
        Observacion: address.Observacion,
        Movil: address.Movil,
        Latitud: 0,
        Longitud: 0,
        Nif: address.Nif,
        Pointer: 0,
        AvisoEmailRemitente: false,
        AvisoSmsRemitente: false,
        AvisoEmailDestino: false,
        AvisoSmsDestino: false,
        Defecto: address.Defecto
      }
    })
    dispatch('fetchAddresses')
  } catch (error) {
    commit('errorMessage', error.message)
  } finally {
    console.log('La petición para actualizar el estado de una direcciones.')
  } 
} */

/* export async function removeAddress({ commit, dispatch }, id) {
  try {
    await Vue.axios({
      method: "DELETE",
      url: `/domicilios/${id}`
    });
    dispatch("fetchAddresses");
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para actualizar el estado de una direcciones.");
  }
} */

/*export async function getAddress({ commit }, address) {
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/domicilios/${address.id}`
    });
    commit("setAddress", data);
  } catch (error) {
    commit("errorMessage", error.message);
  } finally {
    console.log("La petición para actualizar una direcciones ha finalizado.");
  }
}*/
